import { StyleSheet } from 'aphrodite/no-important';
import { color, fontWeight } from '../../../shared/styles/vars';
import { media } from '../../../shared/styles/constants';

export const playerStyles = StyleSheet.create({

    playerCont: {
        display: 'block',
        position: 'relative',
        minHeight: 'inherit',
        padding: '20px 20px 0',
        backgroundColor: color.cobaltBlue,

        [media.MOBILE]: {
            display: 'inline-block',
            padding: '0',
            height: '100%',
            maxHeight: 'inherit',
            width: '100%'
        },
        [media.AT_LEAST_LAPTOP]: {
            minHeight: 500,
        },
    },

    videoCont: {
        height: '100%',
        marginRight: '370px',

        [media.LAPTOP]: {
            marginRight: '330px',
        },

        [media.TABLET]: {
            marginRight: '310px'
        },

        [media.MOBILE]: {
            width: '100%',
            float: 'none',
        },
        [media.SMALL]: {
            width: '100%',
            float: 'none',
        }
    },

    playerSizes: {
        width: '100%',
        backgroundColor: color.black,
        minHeight: 420,
        [media.LAPTOP]: {
            minHeight: 287
        },

        [media.TABLET]: {
            minHeight: 230
        },
        [media.MOBILE]: {
            width: '100%',
            minHeight: 230,
        },
        [media.SMALL]: {
            width: '100%',
            minHeight: 211,
        }
    },
    

    playerMeta:{
        [media.MOBILE]: {
            margin: '0px 10px',
            transition: 'all .3s ease-out',
        }

    },

    playlist: {
        width: '100%',
        maxWidth: '370px',
        height: '100%',
        float: 'right',
        overflowY: 'auto',
        position: 'absolute',
        top: '20px',
        right: '10px',
        '::-webkit-scrollbar': { 
            display: 'none',
        },
        [media.LAPTOP]: {
            maxWidth: '330px',
        },
        [media.TABLET]: {
            maxWidth: '310px',
        },
        [media.MOBILE]: {
            maxWidth: '100%',
            position: 'relative',
            top: '0px',
            right: '0px',
            display: 'block',
            float: 'none',
            '-webkit-overflow-scrolling': 'touch',
        }
    },

    title: {
        fontFamily: 'Antenna',
        fontSize: '18px',
        fontWeight: fontWeight.bold,
        lineHeight: 1.39,
        textAlign: 'left',
        color: color.white,
        margin: '10px 0',

        [media.MOBILE]: {
            fontSize: 14,
        }
    },

    props: {
		marginBottom: '14px',
		fontSize: '10px',
		lineHeight: '1.43em',
		color: color.gray,
		display: 'flex',
		alignItems: 'center',
		fontWeight: fontWeight.semibold
    },

    moreLinkLabel:{
        fontFamily: 'Antenna',
        fontSize: '12px',
        fontWeight: 500,
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.3px',
        textAlign: 'left',
        color: color.white,
    },

    moreLink: {
        display: 'inline-block',
        width: '100%',
        height: 'auto',
        textAlign:  'center',
        margin: 0,
        textDecoration: 'none'
    },
    
	category: {
        marginRight: '5px',
        textTransform: 'uppercase',
		':before': {
			content: '"|"',
			margin: '0 5px'
        }
        
    },

    unAvailableMsg: {
        width: 292,
        height: 45,
        margin: '0 auto',
        backgroundColor: color.cobaltBlue
    },

    unAvailableMsgLbl: {
        display: 'block',
        textAlign: 'center'
    },

    msgCont: {
        width: '100%',
        height: 45,
        margin: '0 auto'
    },

    msgFontStyle: {
        fontFamily: 'Antenna',
        fontSize: 12,
        fontWeight: 500,
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: '45px',
        verticalAlign: 'middle',
        letterSpacing: '0.1px',
        textAlign: 'center',
        display: 'block',
        color: color.white
    }


});